"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.getMappedCustomAttributeIdSet = exports.getIsLoadingCustomFieldMappings = exports.getCustomFieldMappings = exports.fetchIssueCustomFieldMappingsAction = exports.STATE_KEY = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _groupBy = _interopRequireDefault(require("lodash/groupBy"));
var _fetchHelpers = require("../fetchHelpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const initialState = {
  [_fetchHelpers.STATUS_KEY]: _fetchHelpers.FetchStatus.Initial,
  mappings: {}
};
const issueCustomFieldMappingsSlice = (0, _toolkit.createSlice)({
  name: "issueCustomFieldMappings",
  initialState,
  reducers: {
    issueCustomFieldMappingsFetchStart(state) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Loading;
    },
    issueCustomFieldsFetchSuccess(state, action) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Success;
      const mappings = (0, _groupBy.default)(action.payload, "mappedItemId");
      Object.keys(mappings).forEach(key => {
        const issueCustomAttributeMapping = mappings[key];
        issueCustomAttributeMapping.sort((a, b) => {
          if (!Number.isNaN(a.order) && !Number.isNaN(b.order)) {
            return a.order - b.order;
          }
          return 0;
        });
      });
      state.mappings = mappings;
    }
  }
});
const {
  issueCustomFieldMappingsFetchStart,
  issueCustomFieldsFetchSuccess
} = issueCustomFieldMappingsSlice.actions;
const fetchIssueCustomFieldMappingsAction = () => (dispatch, getState, _ref) => {
  let {
    sdk
  } = _ref;
  dispatch(issueCustomFieldMappingsFetchStart());
  sdk.IssueCustomFields.Mappings.getAll().then(payload => {
    dispatch(issueCustomFieldsFetchSuccess(payload.results));
  });
};
exports.fetchIssueCustomFieldMappingsAction = fetchIssueCustomFieldMappingsAction;
const reducer = exports.reducer = issueCustomFieldMappingsSlice.reducer;
const STATE_KEY = exports.STATE_KEY = issueCustomFieldMappingsSlice.name;
const getIssueCustomFieldMappingsState = state => {
  return state[STATE_KEY];
};
const getIsLoadingCustomFieldMappings = exports.getIsLoadingCustomFieldMappings = (0, _toolkit.createSelector)(getIssueCustomFieldMappingsState, _fetchHelpers.isLoading);
const getCustomFieldMappings = exports.getCustomFieldMappings = (0, _toolkit.createSelector)(getIssueCustomFieldMappingsState, state => state.mappings);
const getMappedCustomAttributeIdSet = exports.getMappedCustomAttributeIdSet = (0, _toolkit.createSelector)(getIssueCustomFieldMappingsState, state => {
  const customFieldMappings = state.mappings;
  const flattenedMappings = Object.values(customFieldMappings).flat();
  return new Set(flattenedMappings.map(mapping => mapping.attributeDefinitionId));
});
//# sourceMappingURL=issueCustomFieldMappings.js.map